import React, { useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from './Navigation';
import { Box } from '@mui/material';
import AIHelpAssistant from './AIHelpAssistant';
import Footer from './Footer';
import OfflineBanner from './OfflineBanner';
import { openCookieSettings } from './CookieConsentBanner';

function Layout({ onSignOut }) {
  const handleOpenCookieSettings = useCallback(() => {
    openCookieSettings();
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navigation onSignOut={onSignOut} />
      <OfflineBanner />
      <Box component="main" sx={{ p: 3, flex: 1 }}>
        <Outlet />
      </Box>
      {/* Footer with legal links */}
      <Footer onOpenCookieSettings={handleOpenCookieSettings} />
      {/* Floating AI Help Assistant Widget */}
      <AIHelpAssistant mode="widget" />
    </Box>
  );
}

export default Layout; 